import { module as Module } from 'modujs'
// import modularLoad from 'modularload'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import barba from '@barba/core'
import { html } from '../utils/environment'
import defaultTransition from '../transitions/defaultTransition'
import homeToArchive from '../transitions/homeToArchive'
import singleToArchive from '../transitions/singleToArchive'
import toHome from '../transitions/toHome'
import toSingle from '../transitions/toSingle'
import firstLoadArchive from '../transitions/firstLoadArchive'
import firstLoadSingle from '../transitions/firstLoadSingle'
import archiveToSingle from '../transitions/archiveToSingle'

gsap.registerPlugin(ScrollTrigger)
export default class extends Module {
  constructor(m) {
    super(m)
  }

  init() {
    barba.init({
      timeout: 10000,
      transitions: [
        defaultTransition,
        homeToArchive,
        archiveToSingle,
        singleToArchive,
        toHome,
        toSingle,
        firstLoadArchive,
        firstLoadSingle,
      ],
    })

    barba.hooks.leave(this.leave.bind(this))
    barba.hooks.afterLeave(this.afterLeave.bind(this))
    barba.hooks.beforeEnter(this.beforeEnter.bind(this))
    barba.hooks.enter(this.enter.bind(this))
    barba.hooks.after(this.after.bind(this))
  }

  leave() {
    if (html.classList.contains('has-menu-open')) {
      this.call('close', null, 'Menu')
    }

    html.classList.add('is-loading')
    html.classList.remove('is-loaded')
    html.classList.remove('is-ready')
  }

  afterLeave(data) {
    this.call('destroy', data.current.container, 'app')
    this.call('destroy', '', 'CategoriesMobile')
    this.call('destroy', '', 'LogoMorph')

    ScrollTrigger.getAll().forEach((trigger) => {
      trigger.kill()
    })
    data.current.container.remove()
  }

  beforeEnter({ next }) {
    const parser = new DOMParser()
    const source = parser.parseFromString(next.html, 'text/html')
    const body = source.querySelector('body')
    const classnames = body.getAttribute('class')

    if (classnames) document.querySelector('body').setAttribute('class', classnames)
  }

  enter(data) {
    window.scrollTo(0, 0)

    requestAnimationFrame(() => {
      html.classList.remove('is-loading')
      html.classList.add('is-loaded')
      this.call('update', data.next.container, 'app')
      this.call('update', '', 'CategoriesMobile')
      this.call('update', '', 'LogoMorph')
    })
  }

  after() {
    html.classList.add('is-ready')
  }
}
